'use client'

import { faro, getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'
import { version } from '../../../package.json'

export default function FrontendObservability() {
  // skip if already initialized
  if (faro.api) {
    return null
  }

  try {
    initializeFaro({
      url: process.env.NEXT_PUBLIC_FARO_URL || '',
      app: {
        name: process.env.NEXT_PUBLIC_FARO_APP_NAME || '',
        namespace: process.env.NEXT_PUBLIC_FARO_APP_NAMESPACE || '',
        version: version,
        environment: process.env.NEXT_PUBLIC_ENV,
      },

      instrumentations: [
        // Mandatory, omits default instrumentations otherwise.
        ...getWebInstrumentations(),

        // Tracing package to get end-to-end visibility for HTTP requests.
        new TracingInstrumentation(),
      ],
    })
  } catch (e) {
    console.error('Error initializing FrontendObservability', e)
    return null
  }
  return null
}
